// Module
var code = `<table class="table transaction-create-table">
    <thead>
    <tr>
      <th>Category</th>
      <th ng-if="\$ctrl.withoutRemarks">Remarks</th>
    </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <gl-category-select
              required
              ng-model="\$ctrl.category"
              single-accounts-only="true"
              is-selectize="true"
              action-type="\$ctrl.actionType"
              ng-change="\$ctrl.categoryChanged()"
          >
          </gl-category-select>
        </td>
        <td ng-if="\$ctrl.withoutRemarks">
          <input type="text" ng-model="\$ctrl.remarks" ng-change="\$ctrl.operation.remarks" required style="margin: 0"/>
        </td>
      </tr>
    </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/gl-payment/gl-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;